import { render } from "./suivi_make_page.vue?vue&type=template&id=7f462874"
import script from "./suivi_make_page.vue?vue&type=script&lang=js"
export * from "./suivi_make_page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__